/*
 * ============================
 * File: index.js
 * Project: Octavia-Admin
 * File Created: Thursday, 9th April 2020 2:11:05 am
 * Author:UILIB
 * AuthorUrl:https://ui-lib.com/
 * -----
 * Last Modified: Saturday, 18th April 2020 9:32:52 pm
 * Modified By: naime hossain (naime.hossain93@gmail.com)
 * -----
 * Copyright 2020 - 2021 UILIB, UILIB
 * ============================
 */

// Imports
import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

Vue.use(Router);

import authRoutes from "./modules/auth";
import accountRoutes from "./modules/account";
import adminRoutes from "./modules/admin";
import ultimateRoutes from "./modules/ultimate";
import suportRoutes from "./modules/support.js";
import extrasRoutes from "./modules/extras.js";
import termsRoutes from "./modules/terms.js";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  },
  routes: [
    // Auth
    ...authRoutes,

    // Terms (public)
    ...termsRoutes,

    // Ultimate
    ...ultimateRoutes,

    // Extras
    ...extrasRoutes,

    // Account
    ...accountRoutes,

    // Support
    ...suportRoutes,

    // Admin
    ...adminRoutes,

  ],
});

router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    store.dispatch("changeThemeLoadingState", true);
  }
  next();
});

router.afterEach(() => {
  setTimeout(() => store.dispatch("changeThemeLoadingState", false), 0);
});

export default router;
